export enum ANTRAG_EINREICHEN_POLLING_EVENTS {
  START_POLLING = 'ANTRAG_EINREICHEN_START_POLLING',
  SUCCESSFUL = 'ANTRAG_EINREICHEN_SUCCESSFUL',
  ERROR = 'ANTRAG_EINREICHEN_ERROR',
}

export enum CAP_UPLOAD_EVENTS {
  START_POLLING = 'CAP_UPLOAD_START_POLLING',
  UPLOAD_SUCCESSFUL = 'CAP_UPLOAD_UPLOAD_SUCCESSFUL',
  UPLOAD_ERROR = 'CAP_UPLOAD_ERROR',
}
